function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M4.852 4.62L7.5.854A.836.836 0 018.846.826l.223.29a1 1 0 010 1.22l-4.276 5.56a1 1 0 01-1.586 0l-2.2-2.86a1 1 0 010-1.22l.224-.29a.803.803 0 011.31.053l.654 1.009a1 1 0 001.657.031z",
  fill: "#36C480",
  fillRule: "evenodd"
});

var SvgCheck = function SvgCheck(props) {
  return React.createElement("svg", _extends({
    width: 10,
    height: 9,
    viewBox: "0 0 10 9"
  }, props), _ref);
};

export default SvgCheck;